module.exports = __webpack_public_path__ + "static/img/icon_thunder_bg@2x.bf0db7c8.png";